import { useState } from "react";
import { motion } from "framer-motion";
import { FileText, Plus } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { eur } from "../../lib/api";

export const SizePicker = ({ p, value, onChange, testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {(p.variants || []).map((v) => (
      <button key={v.id} type="button" onClick={() => onChange(v)} data-testid={`${testid}-${v.id}`}
        className={`h-8 px-3 rounded-full text-xs font-mono-d border transition-colors ${
          value?.id === v.id ? "bg-[#F2B441] border-[#F2B441] text-[#0E2A1C] font-bold" : "border-[#F6EEDC]/30 text-[#E3EADF] hover:border-[#F2B441]"}`}>
        {v.size}
      </button>
    ))}
  </div>
);

export const JProductCard = ({ p, onOpen, index = 0 }) => {
  const { add } = useCart();
  const [v, setV] = useState(p.variants?.[0]);
  return (
    <motion.article
      data-testid={`product-card-${p.id}`}
      initial={{ opacity: 0, y: 50, rotate: index % 2 ? 1.5 : -1.5 }}
      whileInView={{ opacity: 1, y: 0, rotate: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -8 }}
      className="group relative flex flex-col bg-[#143823] rounded-[10px] label-frame p-2.5"
    >
      <button onClick={() => onOpen(p)} data-testid={`product-open-${p.id}`} className="relative overflow-hidden rounded-[6px] aspect-[5/6] bg-[#F6EEDC] text-left">
        <img src={p.image} alt={`Etiqueta Jungle Nutrient ${p.name}`} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.07]" />
        <span className="absolute inset-0 bg-[radial-gradient(circle_at_50%_25%,rgba(255,230,160,0.35),transparent_60%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
        {p.npk && (
          <span className="absolute bottom-3 left-3 font-mono-d text-[11px] tracking-[0.15em] rounded-full bg-[#0E2A1C]/85 backdrop-blur-md border border-[#F2B441]/50 px-3 py-1 text-[#F2B441]">
            NPK {p.npk}
          </span>
        )}
      </button>
      <div className="px-3 pt-5 pb-3 flex flex-col gap-4 flex-1">
        <div>
          <p className="font-mono-d text-[10px] tracking-[0.22em] uppercase text-[#8CD05A]">{p.category}</p>
          <h3 className="font-label text-4xl leading-none mt-2 text-label-gold">{p.name}</h3>
          <p className="text-[#C9D6C2] text-sm mt-2">{p.subtitle}</p>
        </div>
        <p className="text-[#C9D6C2] text-sm leading-relaxed">{p.desc}</p>
        <div className="grid grid-cols-2 gap-3 border-y border-[#F2B441]/20 py-3 font-mono-d text-[11px]">
          <div><p className="text-[#C9D6C2]">Dosis</p><p className="text-[#F6EEDC] mt-1">{p.dose}</p></div>
          <div><p className="text-[#C9D6C2]">Aplicación</p><p className="text-[#F6EEDC] mt-1">{p.phase}</p></div>
        </div>
        <SizePicker p={p} value={v} onChange={setV} testid={`product-size-${p.id}`} />
        <div className="flex items-center justify-between gap-2 mt-auto">
          <span data-testid={`product-price-${p.id}`} className="font-serif-d font-black text-3xl">{eur(v?.price ?? p.price)}</span>
          <div className="flex items-center gap-2">
            <button onClick={() => onOpen(p)} data-testid={`product-sheet-btn-${p.id}`} aria-label="Ficha técnica"
              className="w-11 h-11 rounded-full border border-[#F6EEDC]/30 grid place-items-center hover:border-[#F2B441] hover:text-[#F2B441] transition-colors">
              <FileText className="w-4 h-4" />
            </button>
            <button data-testid={`product-add-to-cart-${p.id}`} onClick={() => add(p, 1, false, v)}
              className="group/btn inline-flex items-center gap-2 rounded-full bg-[#F2B441] text-[#0E2A1C] pl-5 pr-1.5 h-11 text-sm font-bold hover:bg-[#F6EEDC] transition-colors active:scale-95">
              Añadir
              <span className="w-8 h-8 rounded-full bg-[#0E2A1C] text-[#F2B441] grid place-items-center transition-transform duration-500 group-hover/btn:rotate-90">
                <Plus className="w-4 h-4" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </motion.article>
  );
};
